import { useContext } from 'react';
import AuthContext from 'src/contexts/Auth0Context';

const useAuth = () => {

    const context = useContext(AuthContext);
    return {
        ...context,
        isDemo: context?.user?.email?.includes('+analytiks@')
    }
};

export default useAuth;
